import {getRouteFromCookie} from '../../api/helpers/cookieHelper';
import {useSecurityStore} from '../../stores/securityStore';
import {unwrapRouteQueryValue} from '../../shared/helpers/routeHelper';
import {useInformationStore} from '../../stores/informationStore';

const readTokens = to => {
    const fragment = new URLSearchParams(to.hash.replace(/^#/, ''));

    if (fragment.has('token') && fragment.has('refreshToken')) {
        return {
            token: fragment.get('token'),
            refreshToken: fragment.get('refreshToken'),
            authType: fragment.get('authType'),
        };
    }

    if ('token' in to.query && 'refreshToken' in to.query) {
        return {
            token: unwrapRouteQueryValue(to.query.token),
            refreshToken: unwrapRouteQueryValue(to.query.refreshToken),
            authType: 'authType' in to.query ? unwrapRouteQueryValue(to.query.authType) : null,
        };
    }

    return null;
};

/**
 *
 * @param {RouteLocationNormalized} to
 * @return {NavigationGuardResult}
 */
export const authorizeWithQueryToken = async to => {
    const tokens = readTokens(to);

    if (!tokens) {
        return;
    }

    const securityStore = useSecurityStore();
    const {refresh} = useInformationStore();

    securityStore.token = tokens.token;
    securityStore.refreshToken = tokens.refreshToken;
    securityStore.authType = tokens.authType;

    delete to.query.token;
    delete to.query.refreshToken;
    delete to.query.authType;
    to.hash = '';

    try {
        await refresh();

        if (['DayBookingOverview', 'FavoriteSeats', 'PresentList'].includes(to.name)) {
            return to;
        }

        return getRouteFromCookie() || {name: 'Home', query: to.query};
    } catch {
        securityStore.clearToken(true);

        return {name: 'Login'};
    }
};
